import { Sizes } from "../../constants/size";
import type { IconProps } from "../../types/icon-props";

export const VideoPlay = (props: IconProps) => {
  const {
    size = "md",
    fill = "var(--grey-1)",
    stroke = "var(--grey-1)",
    ...rest
  } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 17 16"
      fill="none"
      {...rest}
    >
      <path
        d="M3.68726 12.312H13.3123V7.68701H3.68726V12.312ZM4.60913 4.78076L3.29663 5.12646L3.23608 5.14307L3.25171 5.20361L3.49487 6.1001L3.51147 6.16064L3.57104 6.14502L5.78394 5.56006L5.93042 5.52197L5.79956 5.4458L4.65601 4.78662L4.63354 4.77393L4.60913 4.78076ZM8.28979 3.80908L6.66772 4.23682L6.52124 4.27588L6.6521 4.35107L7.79565 5.01123L7.81812 5.02393L7.84253 5.01807L9.4646 4.58936L9.61108 4.55127L9.48022 4.4751L8.33667 3.81494L8.31421 3.80225L8.28979 3.80908ZM12.3181 2.74658L10.3484 3.26514L10.2019 3.30322L10.3328 3.37939L11.4763 4.04053L11.4988 4.05322L11.5232 4.04639L12.5945 3.76416L12.655 3.74756L12.6384 3.68701L12.3943 2.79053L12.3777 2.73096L12.3181 2.74658ZM2.31226 6.9917L2.3103 6.98389L1.85425 5.30518V5.3042C1.81328 5.1558 1.80218 5.00081 1.82202 4.84814C1.84186 4.69555 1.89201 4.54848 1.96948 4.41553V4.41455C2.04697 4.27965 2.15054 4.16132 2.27417 4.06689C2.36686 3.99612 2.46989 3.94024 2.57886 3.8999L2.69019 3.86475L12.2107 1.35205C12.5117 1.27264 12.8323 1.31521 13.1023 1.47021C13.3384 1.60582 13.5196 1.81801 13.6169 2.06982L13.6531 2.18018L14.1638 4.05518C14.1875 4.1426 14.1931 4.2339 14.1814 4.32373C14.1697 4.41369 14.1408 4.50104 14.0955 4.57959C14.0501 4.65798 13.9897 4.72674 13.9177 4.78174C13.8457 4.83675 13.7631 4.87676 13.6755 4.8999L8.79175 6.18896L8.80737 6.31201H13.9998C14.1821 6.31201 14.3572 6.38523 14.4861 6.51416C14.6148 6.64299 14.6872 6.8174 14.6873 6.99951V12.4995C14.6873 12.8144 14.5623 13.1167 14.3396 13.3394C14.1169 13.5621 13.8147 13.687 13.4998 13.687H3.49976C3.18488 13.687 2.88257 13.562 2.65991 13.3394C2.43737 13.1167 2.31226 12.8143 2.31226 12.4995V6.9917Z"
        fill="#E8E2D8"
        stroke="#E8E2D8"
        strokeWidth="0.125"
      />
    </svg>
  );
};

VideoPlay.displayName = "VideoPlay";
